module.exports = __webpack_public_path__ + "media/images/sample_img06-975e09dc86a4961c20ae6411586ebe65.png";